import { BiErrorAlt } from 'react-icons/bi';
import { classBt, classbtAzul } from '../../Utils/Types';
import React from 'react';


type Props = {

    buttonConfirmClick?: () => void,
}

export const ModalAlert = React.memo(({ buttonConfirmClick }: Props) => {

    const handleModalClose = () => {
        let modal = document.getElementById('modal_alert');

        if (modal) {
            modal.style.visibility = 'hidden';
            let modalContent = document.getElementById('modal_content_alert');

            if (modalContent) {
                modalContent.classList.add('mt-[-400px]');
                modalContent.classList.remove('mt-24');
            }
        }
    }

    const handleConfirmClick = () => {
        handleModalClose()

        if (buttonConfirmClick) {
            buttonConfirmClick()
        }
    }

    return (

        <div id="modal_alert" style={{ visibility: "hidden", backgroundColor: 'rgba(0,0,0, 0.6)' }} className={`flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-40`}>

            <div id="modal_content_alert" className={`relative flex flex-col w-3/4 sm:w-[70%] md:w-[60%] lg:[50%] xl:w-[25%] h-[250px] bg-white dark:bg-slate-600 rounded-lg mt-[-400px] transition-all duration-300 justify-center items-center`}>


                <div className={`absolute top-0 flex flex-row w-full h-[70px] items-center`}>
                    <div className={`mx-auto flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full bg-[#8f8638] border-2 border-amber-300 shadow-sm shadow-black mt-6 mb-4`}>
                        <BiErrorAlt className={`text-[#FACC15] w-10 h-10`} />
                    </div>
                </div>

                <div className={`absolute top-[70px] bottom-[60px] w-full pt-4`}>

                    <div className={`flex justify-center`}>
                        <span className={`text-base font-semibold leading-6 text-slate-800 dark:text-slate-200`}>Alerta</span>
                    </div>

                    <div className={`mt-1 mb-6 w-full flex justify-center px-2`}>
                        <p className={`text-base text-slate-600 dark:text-slate-100 pl-2 pr-2 w-full h-full flex justify-center items-center`}>Deseja fechar sem salvar as configurações?</p>
                    </div>

                </div>


                <div className={`absolute bottom-0 w-full h-[60px] flex items-center justify-end bg-slate-100 dark:bg-slate-600 border border-slate-200 dark:border-slate-500 border-x-0 border-b-0 py-4 px-3 rounded-b-lg space-x-3`}>

                    <button
                        onClick={handleModalClose}
                        className={`${classBt} max-w-[150px] text-black dark:text-slate-100 ring-1 ring-inset ring-slate-300 hover:ring-black dark:ring-slate-400 dark:hover:bg-slate-500 mx-3`}>

                        NÃO
                    </button>


                    <button
                        onClick={handleConfirmClick}
                        className={`${classbtAzul} ${classBt} max-w-[150px] mx-1`}>

                        SIM
                    </button>

                </div>

            </div>

        </div>

    )

})